import React, { createContext, FC, ReactNode, useContext, useState } from 'react';

import { EventMode } from './types';

interface EventModeContextProps {
    eventMode: EventMode;
    setEventMode: (mode: EventMode) => void;
}

const EventModeContext = createContext<EventModeContextProps | undefined>(undefined);

export const EventModeProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [eventMode, setEventMode] = useState<EventMode>(null);

    return <EventModeContext.Provider value={{ eventMode, setEventMode }}>{children}</EventModeContext.Provider>;
};

export const useEventMode = () => {
    const context = useContext(EventModeContext);
    if (!context) {
        throw new Error('useEventMode must be used within an EventModeProvider');
    }
    return context;
};
